import MarkdownIt from "markdown-it";
import * as customParsers from "@/utils/Markdown/parser";
import { inhaltsverzeichnisPlugin } from "@/utils/Markdown/plugins/inhaltsverzeichnis-plugin.js";
import { linkMetaPlugin } from "@/utils/Markdown/plugins/link-meta.js";

export const markdownItNoAutoLink = new MarkdownIt({
  typographer: true,
  linkify: false,
  html: false,
})
.use(customParsers.galleryParser)
.use(customParsers.spacerParser)
.use(customParsers.brParser)
.use(customParsers.imgRowParser)
.use(customParsers.viewParser)
.use(customParsers.anchorParser)
.use(linkMetaPlugin)
.use(inhaltsverzeichnisPlugin);
